import { Marker } from '@react-google-maps/api';

import { Place } from '@barboxx/models';

const image =
    // 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';
    'https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/bar-71.png';
// 'https://maps.gstatic.com/mapfiles/place_api/icons/v2/bar_pinlet';

interface Props {
    place: Place;
    onSelect?: (id: string) => void;
}

export function LocalPlaceMarker({ place, onSelect }: Props) {
    const handleClick = () => {
        if (onSelect) {
            onSelect(place.id);
        }
    };

    return (
        <Marker
            position={{ lat: place.latitude, lng: place.longitude }}
            onClick={handleClick}
            options={{
                label: {
                    text: place.name,
                    color: 'white',
                    fontWeight: 'bold',
                },
                icon: {
                    strokeColor: 'green',
                    fillColor: 'blue',
                    scaledSize: new window.google.maps.Size(40, 40),
                    url: image,
                    labelOrigin: new window.google.maps.Point(20, -10),
                },
            }}
        />
    );
}
